export default __webpack_public_path__ + "static/media/add.0106ab9b.svg";